import { FlaskConical } from 'lucide-react'
import { Link, useLocation } from 'react-router'

import { SidebarMenuButton, SidebarMenuItem } from '@/components/ui/sidebar'
import { useUser } from '@/domains/auth'
import { useSetupState } from '@/domains/setup'

export const RESET_DEMO_NAV_HREF = '/super/reset-demo-data'

/** sits with the bell and messages rather than in the Platform group: it is the
 *  thing staff reach for between demos, and hunting for it mid-call is the
 *  failure mode. gated on super *scope*, not just isSuper, to match the route's
 *  own RequireSuper -- otherwise it renders while acting as a tenant and links
 *  somewhere that redirects to /. */
export function ResetDemoButton() {
  const { user } = useUser()
  const { setupState } = useSetupState()
  const location = useLocation()
  if (!user?.isSuper || setupState?.scope !== 'super') return null

  return (
    <SidebarMenuItem>
      <SidebarMenuButton
        asChild
        tooltip='Reset Demo Data'
        isActive={location.pathname === RESET_DEMO_NAV_HREF || undefined}
      >
        <Link to={RESET_DEMO_NAV_HREF}>
          <FlaskConical />
          <span>Reset Demo Data</span>
        </Link>
      </SidebarMenuButton>
    </SidebarMenuItem>
  )
}
